import { Alert, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { accountsApi } from "./api";
import { AccountsGate } from "./AccountsGate";
import { AccessManagementPanel } from "./AccessManagementPanel";
function Users() {
  const scope={kind:"tenant" as const};
  const query=useQuery({queryKey:["account-access",scope],queryFn:()=>accountsApi.listAccess(scope),retry:false});
  return <section className="hosted-content-card accounts-page"><div><p className="hosted-kicker">Votre entreprise</p><Title order={1}>Utilisateurs</Title><Text c="dimmed" mt="xs">Gérez les personnes qui travaillent dans votre espace partagé.</Text></div>
    {query.isLoading ? <Text>Chargement des utilisateurs…</Text> : null}{query.isError ? <Alert color="red">{query.error.message}</Alert> : null}
    {query.data ? <AccessManagementPanel scope={scope} access={query.data} /> : null}
  </section>;
}
export function TenantUsersPage() { return <AccountsGate><Users /></AccountsGate>; }
